import { supabase } from './supabase'

export async function rollbackJournal(
  journalId: string | null,
  tenantId: string,
  reason: string = 'Auto-voided: subsequent operation failed'
): Promise<void> {
  if (!journalId) return

  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { error } = await (supabase as any)
      .from('journal_entries')
      .update({
        is_voided: true,
        void_reason: reason,
        voided_at: new Date().toISOString(),
      })
      .eq('id', journalId)
      .eq('tenant_id', tenantId)

    if (error) {
      console.error('[Rollback] Void failed:', error)
      return
    }

    console.log('[Rollback] Journal voided:', journalId, '| Reason:', reason)
  } catch (err) {
    console.error('[Rollback] Error:', err)
  }
}
